import React from "react"
import "./index.scss"
import RightArrow from "../../assets/svg/040-chevron-right.svg"

const Breadcrumb = ({breadcrumbData, clickNavItem}) => {
  const totalItems = breadcrumbData.length
  let domItems = []
  //cancel the click event for the last breadcrumb item
  function handleClick(event, item, index) {
    if (index === totalItems - 1) event.preventDefault()
    else if (clickNavItem) clickNavItem(item)
  }
  breadcrumbData.forEach((item, index) => {
    domItems.push(
      <span
        data-testid="breadcrumb-items"
        key={item.key}
        className={item.className}
        onClick={(event) => handleClick(event, item, index)}
      >
        {item.label}
      </span>
    )
    if (index < totalItems - 1) {
      domItems.push(
        <div className="breadcrumb-item-separator-container">
          <img
            key={"arrow" + item.key}
            src={RightArrow}
            className="breadcrumb-item-separator"
            alt=">"
          />
        </div>
      )
    }
  })
  return (
    <div data-testid="breadcrumb" className="breadcrumb">
      {domItems}
    </div>
  )
}
export default Breadcrumb
